const initialState = {
  stock: [],
  movements: [],
  alerts: [],
  warehouses: [],
  selectedStock: null,
  loading: false,
  actionLoading: false,
  error: null
};

const StockReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Stock
    case 'FETCH_STOCK_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_STOCK_SUCCESS':
      return { ...state, loading: false, stock: action.payload, error: null };
    case 'FETCH_STOCK_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Fetch Stock Movements
    case 'FETCH_MOVEMENTS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_MOVEMENTS_SUCCESS':
      return { ...state, loading: false, movements: action.payload, error: null };
    case 'FETCH_MOVEMENTS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Create Stock Adjustment
    case 'CREATE_ADJUSTMENT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CREATE_ADJUSTMENT_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        error: null
      };
    case 'CREATE_ADJUSTMENT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Get Product Stock
    case 'GET_PRODUCT_STOCK_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_PRODUCT_STOCK_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        selectedStock: action.payload,
        error: null
      };
    case 'GET_PRODUCT_STOCK_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Fetch Stock Alerts
    case 'FETCH_ALERTS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_ALERTS_SUCCESS':
      return { ...state, loading: false, alerts: action.payload, error: null };
    case 'FETCH_ALERTS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Resolve Alert
    case 'RESOLVE_ALERT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'RESOLVE_ALERT_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        alerts: state.alerts.filter((a) => a.id !== action.payload),
        error: null
      };
    case 'RESOLVE_ALERT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Fetch Warehouses
    case 'FETCH_WAREHOUSES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_WAREHOUSES_SUCCESS':
      return { ...state, loading: false, warehouses: action.payload, error: null };
    case 'FETCH_WAREHOUSES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'TRANSFER_STOCK_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };

    case 'TRANSFER_STOCK_SUCCESS':
      return {
        ...state,
        loading: false,
        error: null
      };

    case 'TRANSFER_STOCK_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default StockReducer;
